export default "__VITE_ASSET__CLnT5fk9__"